function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "dashboard-chrome_svg__a",
  width: "170%",
  height: "170%",
  x: "-35%",
  y: "-25%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 1,
  "in": "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1,
  "in": "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0",
  "in": "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2,
  "in": "SourceAlpha",
  result: "shadowOffsetOuter2"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.5,
  "in": "shadowOffsetOuter2",
  result: "shadowBlurOuter2"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.196078431 0 0 0 0 0.196078431 0 0 0 0 0.364705882 0 0 0 0.1 0",
  "in": "shadowBlurOuter2",
  result: "shadowMatrixOuter2"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  "in": "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  "in": "shadowMatrixOuter2"
}))), /*#__PURE__*/React.createElement("filter", {
  id: "dashboard-chrome_svg__c",
  width: "104.8%",
  height: "173.3%",
  x: "-2.4%",
  y: "-26.7%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 1,
  "in": "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1,
  "in": "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0",
  "in": "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2,
  "in": "SourceAlpha",
  result: "shadowOffsetOuter2"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.5,
  "in": "shadowOffsetOuter2",
  result: "shadowBlurOuter2"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.196078431 0 0 0 0 0.196078431 0 0 0 0 0.364705882 0 0 0 0.1 0",
  "in": "shadowBlurOuter2",
  result: "shadowMatrixOuter2"
}), /*#__PURE__*/React.createElement("feMorphology", {
  radius: 0.25,
  operator: "dilate",
  "in": "SourceAlpha",
  result: "shadowSpreadOuter3"
}), /*#__PURE__*/React.createElement("feOffset", {
  "in": "shadowSpreadOuter3",
  result: "shadowOffsetOuter3"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.196078431 0 0 0 0 0.196078431 0 0 0 0 0.364705882 0 0 0 0.03 0",
  "in": "shadowOffsetOuter3",
  result: "shadowMatrixOuter3"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  "in": "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  "in": "shadowMatrixOuter2"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  "in": "shadowMatrixOuter3"
}))), /*#__PURE__*/React.createElement("filter", {
  id: "dashboard-chrome_svg__f",
  width: "170%",
  height: "170%",
  x: "-35%",
  y: "-25%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 1,
  "in": "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1,
  "in": "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0",
  "in": "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2,
  "in": "SourceAlpha",
  result: "shadowOffsetOuter2"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.5,
  "in": "shadowOffsetOuter2",
  result: "shadowBlurOuter2"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.196078431 0 0 0 0 0.196078431 0 0 0 0 0.364705882 0 0 0 0.1 0",
  "in": "shadowBlurOuter2",
  result: "shadowMatrixOuter2"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  "in": "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  "in": "shadowMatrixOuter2"
}))), /*#__PURE__*/React.createElement("circle", {
  id: "dashboard-chrome_svg__b",
  cx: 15,
  cy: 15,
  r: 15
}), /*#__PURE__*/React.createElement("circle", {
  id: "dashboard-chrome_svg__e",
  cx: 15,
  cy: 15,
  r: 15
}), /*#__PURE__*/React.createElement("rect", {
  id: "dashboard-chrome_svg__d",
  width: 460,
  height: 30,
  rx: 4
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F1F5F9",
  d: "M21.73 269.93a8.002 8.002 0 11-15.46 4.14 8.002 8.002 0 0115.46-4.14z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#AAB7C4",
  d: "M14 280a8 8 0 110-16 8 8 0 010 16zm4.86-12.87a6.9 6.9 0 00-11.25 7.38l.2-.05a4.97 4.97 0 018.38-4.65l-4.37 4.36a4.98 4.98 0 107.04-7.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#424770",
  d: "M17.02 271.19a3.13 3.13 0 11-6.04 1.62 3.13 3.13 0 016.04-1.62z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#87BBFD",
  d: "M14 313a8 8 0 111.34-15.88V302H17v1.67h4.88A8 8 0 0114 313zm2-6h-3.66a.34.34 0 01-.34-.36v-3.63H9.57a.34.34 0 00-.24.1l-2.23 2.23a6.9 6.9 0 006.57 6.57l2.22-2.23c.07-.06.1-.15.1-.24v-2.45z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6772E5",
  d: "M21.89 303.69l-3.21 3.2a.34.34 0 01-.24.1h-2.45v-3.64a.34.34 0 00-.33-.34H12v-2.45c0-.1.04-.18.1-.24l3.2-3.2a8 8 0 016.58 6.57z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#424770",
  d: "M19.44 194.86a8 8 0 10-10.89 0c1.05-.96 3.1-1.64 5.45-1.64 2.36 0 4.41.67 5.44 1.64zM14 190.23a3.08 3.08 0 100-6.15 3.08 3.08 0 000 6.15z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#AAB7C4",
  d: "M19.94 194.35a7.98 7.98 0 01-11.88 0c.7-1.3 3.1-2.27 5.94-2.27 2.85 0 5.24.96 5.94 2.27z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#424770",
  d: "M19.59 333.66h.33l.34.16c.34.16.74.64.74 1.1v7.06c0 .37-.4.7-.74.86l-5.73 2.77c-.12.06-.25.09-.53.09v-6.02H8.66v-5.33l7.04-2.6.12-.1 2.48 1.2-.34.83 1.63-.02z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#AAB7C4",
  d: "M14 337.41v8.25s-.55.02-.71-.05l-5.76-2.75a.95.95 0 01-.53-.87v-7.29c0-.36.2-.7.53-.86l6.1-2.88a.88.88 0 01.77 0l1.76.84-6.92 3.3a.47.47 0 00-.25.42v2.03L11 338.6v-2.1c0-.18.1-.34.26-.42l6.9-3.31 2 .95c.18.1.34.27.5.43L14 337.4z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#AAB7C4",
  d: "M15 96.03v-3.4a.6.6 0 00-.61-.6H12.6a.6.6 0 00-.6.6v3.4H8a1 1 0 01-1-1v-7a1 1 0 01.56-.9l5.96-4.89 5.9 4.9a1 1 0 01.58.9v7a1 1 0 01-1 1h-4zm-1.5-6.2a1.3 1.3 0 100-2.6 1.3 1.3 0 000 2.6z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#424770",
  d: "M13.46 82a.4.4 0 00-.3.09L6 87.87a.4.4 0 00-.06.57l.75.93c.14.17.4.2.57.06l6.2-5.02 6.18 5.02a.4.4 0 00.57-.06l.75-.93a.4.4 0 00-.06-.57l-7.13-5.77a.4.4 0 00-.3-.09z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#AAB7C4",
  d: "M12.67 122.85V125H5c-.55 0-1-.41-1-.92v-6.16c0-.5.45-.92 1-.92h12c.55 0 1 .41 1 .92v4.93h-5.33zM11 119a2 2 0 100 4 2 2 0 000-4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#424770",
  d: "M21 129H9c-.55 0-1-.41-1-.92v-6.16c0-.5.45-.92 1-.92h12c.55 0 1 .41 1 .92v6.16c0 .5-.45.92-1 .92zm-6-6a2 2 0 100 4 2 2 0 000-4z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#AAB7C4",
  d: "M8.5 544a1.5 1.5 0 01-1.5-1.5v-6.46c.38.14 1.22.22 1.65.26l.04 3.2c0 .28.23.5.51.5h9.69c.28 0 .5-.22.5-.5l-.05-3.2c.82-.04 1.67-.12 1.66-.26v6.46c0 .83-.68 1.5-1.5 1.5h-11z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#424770",
  d: "M21.98 532.55l.01.03v.09l-.02.16a2.76 2.76 0 01-2.8 2.44c-1 0-1.88-.5-2.38-1.26a3.5 3.5 0 01-2.79 1.27 3.5 3.5 0 01-2.8-1.28 2.85 2.85 0 01-2.38 1.26 2.76 2.76 0 01-2.81-2.6v-.09l.01-.03c.02-.12.05-.24.11-.37l.71-1.15.07-.1.4-.64c.25-.5 1.1-1.28 1.91-1.28h9.53c.81 0 1.67.78 1.93 1.3l.4.63.06.1.72 1.15c.06.13.09.25.1.37z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(7 497)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#424770",
  d: "M10.5.938L14 7l-3.5 6.062h-7L0 7 3.5.938z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 7,
  cy: 7,
  r: 3,
  fill: "#F6F9FC"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#424770",
  d: "M224.37 537.72l-3.47 3.46a.71.71 0 00.01 1 .7.7 0 001 0l4.6-4.59a.7.7 0 00.2-.5.7.7 0 00-.2-.49l-4.6-4.6a.7.7 0 00-1 .01.71.71 0 000 1l3.28 3.29h-7.47c-.4 0-.72.32-.72.71 0 .4.31.71.72.71h7.65z"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#424770"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22 416.3c0-.72-.59-1.3-1.3-1.3H7.3c-.7 0-1.3.59-1.3 1.3v8.7h16v-8.7zm-13.65 3.88a.602.602 0 00.49 1.1l2.56-1.17c.3-.14.83-.53.96-1.06-.13-.53-.66-.93-.96-1.06l-2.56-1.14a.604.604 0 00-.5 1.1l2.85 1.1-2.84 1.12zM22 425.35V425H6v.69c0 .73.59 1.31 1.3 1.31h13.4c.71 0 1.3-.59 1.3-1.3v-.35z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(6 380)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 8,
  fill: "#AAB7C4"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F1F5F9",
  d: "M11.62 12.8A5.99 5.99 0 008 2a6.01 6.01 0 00-3.62 10.8",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F1F5F9",
  d: "M9.63 10.15A2.7 2.7 0 008 5.3a2.7 2.7 0 00-1.63 4.87",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 1.87,
  fill: "#424770"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#AAB7C4",
  d: "M11.95 151.81v5.64a1 1 0 01-1 1 1 1 0 01-1-1v-5.62l-1.83 1.82a1 1 0 11-1.41-1.4l3.53-3.55a1 1 0 01.72-.3 1 1 0 01.71.3l3.53 3.54a1 1 0 11-1.4 1.41l-1.85-1.84z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#424770",
  d: "M18.54 161.14v-5.64a1 1 0 00-1-1 1 1 0 00-1 1v5.62l-1.84-1.82a1 1 0 10-1.42 1.4l3.54 3.54a1 1 0 001.43 0l3.53-3.53a1 1 0 10-1.41-1.41l-1.84 1.84z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#AAB7C4",
  d: "M19.79 238.3h2.18a8 8 0 11-2.18-4.81v4.8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F6F9FC",
  d: "M18.73 243.24c.23 0 .42.15.42.38 0 .16-.11.32-.23.42a6.76 6.76 0 01-4.45 1.78c-3.8 0-6.3-3.08-6.3-6.08 0-2.82 2.32-5.23 4.93-5.23 2.6 0 3.63 1.79 3.63 1.79l1.7 7.07a.42.42 0 01.3-.13z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#424770",
  d: "M22 239c0-.33-.27-.66-.6-.66a.6.6 0 00-.6.61 6.35 6.35 0 01-1.15 3.4 5.52 5.52 0 01-4.42 2.31c-2.54 0-4.4-1.92-4.4-3.97 0-1.43.96-2.39 1.94-2.39.53 0 .83.23.99.44.12.15.35.16.5.02l5.4-5.42A7.98 7.98 0 0122 239z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(3 447)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 23,
  height: 14,
  fill: "#AAB7C4",
  rx: 7
}), /*#__PURE__*/React.createElement("circle", {
  cx: 7,
  cy: 7,
  r: 6,
  fill: "#FFF"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(3 22)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#424770",
  d: "M220.3 18.7a.7.7 0 00.5-.2l4.59-4.6a.7.7 0 000-1 .71.71 0 00-1 0l-4.1 4.09-4.08-4.09a.71.71 0 00-1 0 .7.7 0 000 1l4.59 4.6c.13.14.31.2.5.2z"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#dashboard-chrome_svg__a)",
  xlinkHref: "#dashboard-chrome_svg__b"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#dashboard-chrome_svg__b"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#AAB7C4",
  d: "M9.5 22A1.5 1.5 0 018 20.5v-6.46c.38.14 1.22.22 1.65.26l.04 3.2c0 .28.23.5.51.5h9.69c.28 0 .5-.22.5-.5l-.05-3.2c.82-.04 1.67-.12 1.66-.26v6.46c0 .83-.68 1.5-1.5 1.5h-11z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#424770",
  d: "M22.98 10.55l.01.03v.09l-.02.16a2.76 2.76 0 01-2.8 2.44c-1 0-1.88-.5-2.38-1.26A3.5 3.5 0 0115 13.28 3.5 3.5 0 0112.2 12a2.85 2.85 0 01-2.38 1.26 2.76 2.76 0 01-2.81-2.6v-.09l.01-.03c.02-.12.05-.24.11-.37l.71-1.15.07-.1.4-.64C8.56 7.78 9.41 7 10.22 7h9.53c.81 0 1.67.78 1.93 1.3l.4.63.06.1.72 1.15c.06.13.09.25.1.37z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(256 22)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#dashboard-chrome_svg__c)",
  xlinkHref: "#dashboard-chrome_svg__d"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#dashboard-chrome_svg__d"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#8898AA"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.25 19.5a5.25 5.25 0 110-10.5 5.25 5.25 0 010 10.5zm0-1.23a4.02 4.02 0 100-8.04 4.02 4.02 0 000 8.04z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.54 18.14l1.06-1.06 2.6 2.6c.3.3.3.76 0 1.06-.3.3-.77.3-1.06 0l-2.6-2.6z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(986 22)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "dashboard-chrome_svg__g",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#dashboard-chrome_svg__e"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#dashboard-chrome_svg__f)",
  xlinkHref: "#dashboard-chrome_svg__e"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#dashboard-chrome_svg__e"
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#dashboard-chrome_svg__g)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#424770",
  d: "M15 17.3a5.08 5.08 0 100-10.15 5.08 5.08 0 000 10.16z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#AAB7C4",
  d: "M23.92 23.03a11.97 11.97 0 01-17.84 0c1.06-1.97 4.65-3.41 8.92-3.41s7.86 1.44 8.92 3.41z"
}))), /*#__PURE__*/React.createElement("path", {
  fill: "#424770",
  d: "M953.65 45.2a2.72 2.72 0 005.3 0h-5.3zm7.92-8.13a13.6 13.6 0 002.03 5.11c.59.86-.05 1.98-1.13 1.82h-12.12c-1.08.16-1.7-.96-1.13-1.82a13.3 13.3 0 002.1-5.1c.2-1.13.34-2.12.45-2.97a4.18 4.18 0 014.23-3.56h.86c2.17 0 4 1.53 4.25 3.56.1.84.24 1.83.45 2.96zm-5.14-6.69a1.05 1.05 0 110-2.1 1.05 1.05 0 010 2.1zM916.58 31c2.16 0 3.18.85 3.92 2.13v12.29c-.51 0-1.01-.34-1.33-.6-1.03-.82-3.06-.82-5.22-.82h-1a.94.94 0 01-.95-.95v-11.1c0-.53.42-.95.94-.95h3.64z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#AAB7C4",
  d: "M924.42 31c-2.16 0-3.17.9-3.92 2.1l.01 12.31c.51 0 1.02-.33 1.33-.59 1.03-.82 3.06-.82 5.22-.82h1a.94.94 0 00.95-.95v-11.1a.94.94 0 00-.95-.95h-3.63z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#424770",
  d: "M876.27 40.74l-2.45-1.02s-.4-.14-.55-.64a2.7 2.7 0 010-1.63c.18-.57.55-.73.55-.73s9.63-4.07 13.65-5.43c.53-.18 1.17-.16 1.18-.16 1.95.07 3.35 3.4 3.35 7.27 0 3.87-1.62 6.8-3.35 6.84 0 0-.49.1-1.18-.13-2.2-.74-4.68-1.7-7.37-2.8-.11-.04-.3-.12-.34.18v.6c0 .55-.41.83-.92.62l-1.4-.57a1.6 1.6 0 01-.93-1.37v-.64c.02-.29-.16-.36-.24-.39zm11.98 2.91c1.37 0 2.48-2.46 2.48-5.5s-1.11-5.5-2.48-5.5c-1.37 0-2.47 2.46-2.47 5.5s1.1 5.5 2.47 5.5z"
})));

function SvgDashboardChrome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1020 550"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "static/dashboard-chrome.7d0a6ded.svg";
export { SvgDashboardChrome as ReactComponent };